export default __webpack_public_path__ + "static/media/election2016general.19071550.txt";